// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".training-score-text-top[data-v-59ba3397]{margin-top:30px}.training-score-text[data-v-59ba3397]{margin-top:10px}.training-score-text-middle[data-v-59ba3397]{margin-top:20px}.training-score-text-bottom[data-v-59ba3397]{margin-top:50px}.green[data-v-59ba3397],.training-knowledge[data-v-59ba3397]{color:#2cb774;font-size:20px;display:inline-block;font-weight:700;padding:0 4px}.icon-shoucang[data-v-59ba3397]{color:#ffc13b}", ""]);
// Exports
module.exports = exports;
